export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20workspace%20with%20laptop%20displaying%20spreadsheet%20and%20product%20catalog%20on%20warm%20beige%20desk%2C%20natural%20sunlight%20from%20window%2C%20clean%20aesthetic%20with%20small%20plant%20and%20notebook%2C%20modern%20cozy%20interior%2C%20soft%20shadows%2C%20editorial%20lifestyle%20photography%2C%20cream%20and%20warm%20tones%2C%20blurred%20background%20with%20shelves&width=1600&height=900&seq=hero-bg-vigorbuy&orientation=landscape"
        alt="Vigorbuy Spreadsheet workspace"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 mb-5 text-xs md:text-sm font-medium bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full border border-background-50/30">
            Updated 2026 Product Database
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            Vigorbuy Spreadsheet 2026
            <span className="block text-lg md:text-2xl lg:text-3xl font-normal mt-2 text-background-50/85">
              The Ultimate Product Discovery Database &amp; Shopping Guide
            </span>
          </h1>

          <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto mb-8 leading-relaxed">
            Find trending products faster with our curated Vigorbuy Spreadsheet resources.
            Explore organized product lists, comparison guides, quality information, and expert buying tips designed for smarter shopping decisions.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-md font-semibold text-sm md:text-base hover:bg-primary-400 transition-all duration-200 whitespace-nowrap"
            >
              Vigorbuy Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-md font-semibold text-sm md:text-base hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-5 md:gap-8 mt-10">
            {[
              'Updated Product Database',
              'Organized Categories',
              'Detailed Guides',
              'Beginner Friendly',
              'Safety Resources',
            ].map((badge) => (
              <span key={badge} className="flex items-center gap-1.5 text-xs md:text-sm text-background-50/80 whitespace-nowrap">
                <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}